import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { XCircle, CheckCircle2, AlertCircle } from 'lucide-react';
export function PainPoints() {
  return <section className="w-full py-24 px-6 bg-night-500 relative" data-id="element-148">
      <div className="max-w-3xl mx-auto space-y-24" data-id="element-149">
        {/* Segment 1: Who is this for? */}
        <FadeIn data-id="element-150">
          <div className="space-y-8" data-id="element-151">
            <h2 className="font-serif text-3xl md:text-4xl text-night-50 text-center" data-id="element-152">
              Para quién es esto
            </h2>
            <div className="bg-night-400/50 border border-night-300 rounded-2xl p-8 md:p-10 shadow-lg backdrop-blur-sm" data-id="element-153">
              <p className="text-lg text-night-100 mb-6" data-id="element-154">
                Si estás en USA, hablas español, tienes un bebé de 4–6 meses, y
                tus noches se repiten así:
              </p>
              <ul className="space-y-4" data-id="element-155">
                {['Se duerme… y a los 45–120 minutos vuelve a despertarse', 'Solo se vuelve a dormir con pecho/biberón/arrullo/caminar', 'Tú terminas siendo “la única forma de dormir”', 'En el día estás irritable, sensible, sin paciencia, con la mente lenta', 'Y encima te dices: “debería poder con esto”'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-156">
                    <XCircle className="w-6 h-6 text-red-400/80 shrink-0 mt-0.5" data-id="element-157" />
                    <span className="text-night-50 text-lg" data-id="element-158">{item}</span>
                  </li>)}
              </ul>
              <div className="mt-8 pt-8 border-t border-night-300 text-center" data-id="element-159">
                <p className="font-serif text-xl text-amber-warm italic" data-id="element-160">
                  "Entonces esto es para ti. No porque seas débil. Sino porque
                  nadie puede funcionar sin dormir."
                </p>
              </div>
            </div>
          </div>
        </FadeIn>

        {/* Segment 2: The Truth */}
        <FadeIn data-id="element-161">
          <div className="space-y-8 text-center" data-id="element-162">
            <div className="inline-flex items-center justify-center p-3 bg-night-300 rounded-full mb-4" data-id="element-163">
              <AlertCircle className="w-6 h-6 text-amber-warm" data-id="element-164" />
            </div>
            <h2 className="font-serif text-3xl md:text-4xl text-night-50" data-id="element-165">
              Lo que nadie te dice
            </h2>
            <div className="prose prose-invert prose-lg mx-auto text-night-100" data-id="element-166">
              <p data-id="element-167">
                La mayoría de mamás no falla por “no intentarlo”.
                <br data-id="element-168" />
                Falla por esto:
              </p>
              <p className="text-night-50 font-medium text-xl py-4" data-id="element-169">
                En la noche toman 40 micro-decisiones agotadas, sin un sistema.
              </p>
              <p data-id="element-170">
                Y el bebé aprende exactamente eso: que cada despertar abre una
                negociación diferente.
              </p>
            </div>
          </div>
        </FadeIn>

        {/* Segment 3: Why old solutions fail */}
        <FadeIn data-id="element-171">
          <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-172">
            <div className="space-y-6" data-id="element-173">
              <h3 className="font-serif text-2xl text-night-50" data-id="element-174">
                Por qué “lo que ya probaste” no funcionó
              </h3>
              <p className="text-night-100" data-id="element-175">
                No es porque no quieras. Es porque a las 2–5am tú no estás en
                condiciones de diseñar una estrategia.
              </p>
              <p className="text-amber-warm font-medium" data-id="element-176">
                Necesitas un plan que ya esté diseñado.
              </p>
            </div>
            <div className="bg-night-400 p-6 rounded-xl border border-night-300 space-y-4" data-id="element-177">
              {['Probaste ruido blanco, rutina, baño, oscuridad', 'Probaste “esperar un poquito”… y no pudiste sostenerlo', 'Probaste alimentar “por si acaso”', 'Probaste cambiar algo 2 noches y volviste atrás'].map((item, i) => <div key={i} className="flex items-center gap-3 text-night-100 text-sm md:text-base" data-id="element-178">
                  <div className="w-1.5 h-1.5 rounded-full bg-night-200 shrink-0" data-id="element-179" />
                  <span data-id="element-180">{item}</span>
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}